<template>
  <DealStoryCarousel
    v-if="showCarousel"
    v-bind="componentProps"
  />
</template>

<script>
import DealStoryCarousel from './components/pages/dealDetail/DealStoryCarousel.vue';

export default {
  name: 'DealDetail',
  components: {
    DealStoryCarousel,
  },
  data() {
    return {
      componentProps: {},
      showCarousel: false,
    };
  },
  mounted() {
    window.vueDealAPI = {
      renderDealCarousel: this.renderDealCarousel,
    };
  },
  methods: {
    renderDealCarousel(componentProps) {
      // eslint-disable-next-line no-eval
      const imageArray = eval(componentProps.storyImages);
      this.componentProps = {
        storyImages: imageArray,
        coverImage: componentProps.coverImage,
        coverImageCaption: componentProps.coverImageCaption,
      };
      this.showCarousel = true;
    },
  },
};
</script>
